import { InjectionToken } from '@angular/core';
import { getLocalStorage } from './storage.service';

export const LOCAL_STORAGE = new InjectionToken<Storage>('LOCAL_STORAGE');

export function provideLocalStorage() {
  return {
    provide: LOCAL_STORAGE,
    useFactory: getLocalStorage,
  };
}
